export default __webpack_public_path__ + "static/media/draw-4.b499903f.jpg";